import { PaperClipIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../common/utils/classnames";
import { shortDateFormat } from "../../common/utils/dateformat";
import { EnterpriseAgreementFragment } from "../../graphql/generated";

const EnterpriseAgreementCard: React.FC<{
  agreement?: EnterpriseAgreementFragment;
}> = ({ agreement }) => {
  return (
    <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-3 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
      <div className="flex-shrink-0">
        <PaperClipIcon
          className={classNames(
            agreement?.deletedAt
              ? "bg-red-100 border-red-300"
              : "bg-green-100 border-green-300",
            "h-10 w-10 rounded-full border-2"
          )}
        />
      </div>
      <div className="flex-1 min-w-0">
        <Link
          to={`/enterprise_agreements/${agreement?.id}`}
          className="focus:outline-none"
        >
          <span className="absolute inset-0" aria-hidden="true" />
          <p className="text-sm font-medium text-gray-900 truncate">
            {agreement?.name}
          </p>
          <p className="text-sm text-gray-500 truncate">
            Created: {shortDateFormat(agreement?.createdAt)}
          </p>
          <p className="text-sm text-gray-500 truncate">
            Active Agents: {agreement?.activeAgentCount}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default EnterpriseAgreementCard;
